import * as React from "react";
import { HeaderSearchBlock } from "./header-search-block";

type HeaderProps = {
  backgroundColor?: string;
  tags?:
    | undefined
    | {
        name: string;
        count: number;
        slug: string;
      }[];
};

export const Header: React.FC<HeaderProps> = (props) => {
  return (
    <div
      className="site-subheader"
      style={{ backgroundColor: props.backgroundColor }}
    >
      <div className="container-xxl">
        <div className="row">
          <div className="col">
            <div className="header-logo">
              <a
                href="/the-buzz"
                className="custom-logo-link"
                rel="home"
                aria-current="page"
              >
                <img
                  width="1170"
                  height="1"
                  src="/the-buzz/logo/buzz-logo.svg"
                  className="custom-logo"
                  alt="Bumble Buzz"
                  decoding="async"
                />
              </a>
              <h1 className="screen-reader-text">Bumble Buzz</h1>
            </div>
          </div>
          {/* .col  */}
          <div className="col header-buttons">
            <div className="d-flex align-items-center justify-content-end header-search-tags">
              <div className="flex-shrink-1 header-search-button">
                <HeaderSearchBlock />
              </div>
              {/* .header-search-button  */}
            </div>
            {/* .header-search-tags  */}
          </div>
          {/* .col.header-buttons  */}
        </div>
        {/* .row  */}
      </div>
      {/* .container-xxl  */}
    </div>
  );
};

export default Header;
